var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCubeDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 12,
    height: 2,
    rx: 1,
    fill: "#E3EBF6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 13,
    width: 10,
    height: 2,
    rx: 1,
    transform: "rotate(-90 0 13)",
    fill: "#42BB93"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 2,
    height: 2,
    rx: 1,
    transform: "rotate(180 6 6)",
    fill: "#C8D7EC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 9,
    width: 2,
    height: 2,
    rx: 1,
    transform: "rotate(180 6 9)",
    fill: "#C8D7EC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 12,
    width: 2,
    height: 2,
    rx: 1,
    transform: "rotate(180 6 12)",
    fill: "#C8D7EC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 2,
    height: 2,
    rx: 1,
    transform: "rotate(180 9 6)",
    fill: "#C8D7EC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 2,
    height: 2,
    rx: 1,
    transform: "rotate(180 9 9)",
    fill: "#C8D7EC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 12,
    width: 2,
    height: 2,
    rx: 1,
    transform: "rotate(180 9 12)",
    fill: "#C8D7EC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 6,
    width: 2,
    height: 2,
    rx: 1,
    transform: "rotate(180 12 6)",
    fill: "#C8D7EC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 9,
    width: 2,
    height: 2,
    rx: 1,
    transform: "rotate(180 12 9)",
    fill: "#C8D7EC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 2,
    height: 2,
    rx: 1,
    transform: "rotate(180 12 12)",
    fill: "#C8D7EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCubeDown);
export default __webpack_public_path__ + "static/media/icon-cube-down.e1820b6c284eb3f987184e6e9800a4e6.svg";
export { ForwardRef as ReactComponent };